import SubstituteItem from 'components/ItemSubstitution/SubstituteItem/SubstituteItem';

export default SubstituteItem;
